<div class="quizz-editor">

  <div class="flex items-center justify-between mb-4">
    <div>
      <span class="text-[0.95rem] font-bold text-[#222b45]">Questions</span>
      <span *ngIf="questions?.length"
        class="inline-block ml-2 px-2 py-px rounded-full bg-[#edf1f7] text-[#8f9bb3] text-xs font-semibold">
        {{ questions.length }}
      </span>
    </div>
    <button type="button" nbButton status="success" size="small" (click)="addQuestion($event)">
      <nb-icon icon="plus-outline" pack="eva"></nb-icon>Add question
    </button>
  </div>

  <div *ngIf="!questions?.length"
    class="p-4 border border-dashed border-[#e4e9f2] rounded-lg bg-[#f7f9fc] text-[#8f9bb3] text-sm text-center">
    No question yet. Add a first question to build the quizz.
  </div>

  <div cdkDropList (cdkDropListDropped)="drop($event,questions)">
    <div class="border border-[#e4e9f2] rounded-lg bg-white mb-2 overflow-hidden"
      cdkDrag *ngFor="let question of questions; let i = index"
      [ngClass]="{'border-[#a6c1ff] shadow-[0_2px_8px_rgba(44,51,73,0.08)]': currentQuestion === question}">

      <div class="flex items-center gap-2.5 px-3 py-2.5 cursor-pointer hover:bg-[#f7f9fc]"
        (click)="toggleQuestion(question)">
        <nb-icon class="shrink-0 text-[#c5cee0] cursor-move hover:text-[#8f9bb3]" icon="menu-outline" pack="eva"
          cdkDragHandle (click)="$event.stopPropagation()"></nb-icon>
        <span
          class="shrink-0 size-6 rounded-full bg-[#edf1f7] text-[#222b45] text-xs font-bold leading-6 text-center">
          {{ i+1 }}
        </span>
        <span class="grow min-w-0 overflow-hidden text-ellipsis whitespace-nowrap font-semibold text-[#222b45]"
          [ngClass]="{'font-normal italic text-[#8f9bb3]': !(question.labels | txtTranslate)}">
          {{ (question.labels | txtTranslate) || 'Untitled question' }}
        </span>
        <span
          class="shrink-0 px-2 py-0.5 rounded-full bg-[#edf1f7] text-[#8f9bb3] text-[0.7rem] font-semibold whitespace-nowrap">
          {{ question.answers?.length || 0 }} answer(s)
        </span>
        <span *ngIf="!getCorrectAnswer(question)"
          class="shrink-0 px-2 py-0.5 rounded-full bg-[rgba(255,61,113,0.12)] text-[#ff3d71] text-[0.7rem] font-semibold whitespace-nowrap">
          no correct answer
        </span>
        <button type="button" nbButton ghost status="danger" size="small"
          (click)="deleteQuestion(i);$event.stopPropagation()">
          <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
        </button>
        <nb-icon class="shrink-0 text-[#8f9bb3]"
          [icon]="currentQuestion === question ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'"
          pack="eva"></nb-icon>
      </div>

      <div *ngIf="currentQuestion === question" class="px-3 pt-1 pb-3 border-t border-[#e4e9f2] bg-[#f7f9fc]">
        <label class="block mb-0.5 text-[#8f9bb3] text-[0.7rem] font-bold tracking-wide uppercase">Question</label>
        <multilang-editor [model]="question.labels" editMode="true" [htmlMode]="false" [simple]="true"
          [languages]="languages" [defaultLang]="defaultLang"></multilang-editor>

        <div class="flex items-center justify-between mt-3 mb-1.5">
          <label class="block mb-0.5 text-[#8f9bb3] text-[0.7rem] font-bold tracking-wide uppercase">Answers</label>
          <button type="button" nbButton status="success" size="tiny" (click)="addAnswer(question)">
            <nb-icon icon="plus-outline" pack="eva"></nb-icon>Add answer
          </button>
        </div>

        <div cdkDropList (cdkDropListDropped)="drop($event,question.answers)">
          <div class="border border-[#e4e9f2] border-l-[3px] rounded-md bg-white px-2.5 py-2 mb-1.5"
            cdkDrag *ngFor="let answer of question.answers; let j = index"
            [ngClass]="{'border-l-[#00d68f]': answer.correct}">

            <div class="flex items-start gap-2">
              <nb-icon class="shrink-0 mt-1.5 text-[#c5cee0] cursor-move hover:text-[#8f9bb3]"
                icon="menu-outline" pack="eva" cdkDragHandle></nb-icon>
              <button type="button"
                class="shrink-0 mt-1.5 p-0 border-0 bg-transparent cursor-pointer text-[#c5cee0] hover:text-[#8f9bb3]"
                [ngClass]="{'!text-[#00d68f]': answer.correct}"
                [title]="answer.correct ? 'Correct answer' : 'Mark as the correct answer'"
                (click)="setCorrectAnswer(question,answer)">
                <nb-icon icon="checkmark-circle-2-outline" pack="eva"></nb-icon>
              </button>
              <div class="grow min-w-0">
                <multilang-editor [model]="answer.labels" editMode="true" [htmlMode]="false" [simple]="true"
                  [languages]="languages" [defaultLang]="defaultLang"></multilang-editor>
              </div>
              <button type="button" nbButton ghost status="danger" size="small" (click)="deleteAnswer(question,j)">
                <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
              </button>
            </div>

            <div class="flex flex-wrap gap-4 pl-14">
              <div class="shrink-0 w-[5.5rem]">
                <label class="block mb-0.5 text-[#8f9bb3] text-[0.7rem] font-bold tracking-wide uppercase">Points</label>
                <input nbInput fieldSize="small" class="form-control text-center" type="number"
                  [(ngModel)]="answer.reward" [ngModelOptions]="{standalone: true}" onwheel="return false;">
              </div>
              <div class="basis-64 min-w-0 flex-grow" *ngIf="game?.hasResources">
                <label class="block mb-0.5 text-[#8f9bb3] text-[0.7rem] font-bold tracking-wide uppercase">Bonus resources</label>
                <app-resource-selector [resources]="resources"
                  [resourceQuantities]="answer.selectedResources"></app-resource-selector>
              </div>
            </div>
            <div class="pl-14 mt-2">
              <div class="grow min-w-0">
                <label class="block mb-0.5 text-[#8f9bb3] text-[0.7rem] font-bold tracking-wide uppercase">Message shown when selected</label>
                <multilang-editor [model]="answer.selectedTxt" editMode="true" [htmlMode]="false" [simple]="true"
                  [languages]="languages" [defaultLang]="defaultLang"></multilang-editor>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!question.answers?.length"
          class="p-4 border border-dashed border-[#e4e9f2] rounded-lg bg-[#f7f9fc] text-[#8f9bb3] text-sm text-center">
          No answer yet. Add at least two answers, one of them being the correct one.
        </div>
      </div>
    </div>
  </div>
</div>
